<ng-container>
    <div>
        <ng-container *ngIf="!!title;else NoTitle">
            <h4 class="small-title">{{title}} &nbsp;
                <button class="btn btn-success btn-sm " (click)="grantGroupModal.show()" type="button">選択</button>
            </h4>

        </ng-container>
        <ng-template #NoTitle>
            <button class="btn btn-success btn-sm" (click)="grantGroupModal.show()" type="button">選択</button>
        </ng-template>
    </div>

    <dynamic-data-view *ngIf="!grantGroupModal.isShown" [is_view_mode]="true" [dataType]="'grant_group'" [grantGroupData]="grantGroupData"></dynamic-data-view>

    <div bsModal #grantGroupModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
         aria-hidden="true">
        <div class="modal-dialog modal-primary modal-fixed" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">ユーザー・組織選択</h4>
                    <!--                    <div class="w-100 mt-2">-->
                    <!--                        <input type="text" class="form-control" -->
                    <!--                               [(ngModel)]="searchTerm"-->
                    <!--                               (ngModelChange)="filterGrantGroups()"-->
                    <!--                               placeholder="ユーザー/組織を検索">-->
                    <!--                    </div>-->
                    <button type="button" class="close" (click)="grantGroupModal.hide()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-0">
                    <div *ngIf="searchTerm" class="p-3">
                        <div *ngIf="isSearching" class="text-center py-3">
                            <i class="fa fa-spinner fa-spin"></i> 検索中...
                        </div>
                        <div *ngIf="!isSearching && filteredGroups.length === 0" class="text-center py-3">
                            検索結果がありません
                        </div>
                        <div *ngIf="!isSearching && filteredGroups.length > 0" class="list-group">
                            <button *ngFor="let group of filteredGroups"
                                    class="list-group-item list-group-item-action d-flex align-items-center"
                                    (click)="onInputGrantGroup(group)">
                                <i class="fa" [ngClass]="{'fa-user': group.type === 'user', 'fa-users': group.type === 'group'}" class="mr-2"></i>
                                {{group.name}}
                            </button>
                        </div>
                    </div>
                    <edit-component *ngIf="!searchTerm"
                                    [_mode]="!value?'add':'edit'"
                                    [IS_EMBED_MODE]="true"
                                    [_id]="!value?null:value"
                                    [_table]="'grant_group'"
                                  (onSubmit)="onInputGrantGroup($event)"
                                    (onCancel)="grantGroupModal.hide()"
                                    [is_add_new_button_select_other_table]="false"
                                  [grant_kind]="grant_kind">
                    </edit-component>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

</ng-container>
